<div class="popup-wrapper">
    <div class="popup-header">
        <span class="tax-icon nav-icon " style="width: 20px; height: 20px; background-color: var(--soc-cyan);"></span>
        <span class="soc-panel-h">{{(editFlag ? 'TAX_RATE.EDIT_TAX_RATE' : "TAX_RATE.NEW_TAX_RATE") | translate}}</span>
    </div>
    <hr class="soc-panel-line">
    <form #f="ngForm" class="soc-form-wrapper-gap-24">
        <div class="soc-input-wrapper">
            <label for="name" class="soc-input-lbl w-100 text-start">{{'TAX_RATE.TAX_RATE_NAME'| translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="name.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': name.invalid && f.submitted}" required name="name" #name="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="taxRateDto.name">
            </div>
        </div>
    
        <div class="soc-addon-input-group">
            <label for="rate" class="soc-input-lbl w-100 text-start">{{'TAX_RATE.TAX_RATE_PERCENTAGE' | translate}}</label>
            <div class="soc-error-field-wrapper w-100">
                <span *ngIf="rate.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <div class="p-inputgroup">
                    <input [(ngModel)]="taxRateDto.rate" placeholder="{{'TYPE_HERE' | translate}}" class="soc-input-text w-100" type="text" [ngClass]="{'soc-error-active': rate.invalid && f.submitted }" required name="rate" #rate="ngModel" type="text">   
                    <span class="p-inputgroup-addon soc-input-text"  style="width: 40px !important;" [ngClass]="{'soc-error-active-addon': rate.invalid && f.submitted}">%</span>      
                </div>
            </div>
        </div>

        <app-soc-text-field rowsInput="4" label="{{'TAX_RATE.DESCRIPTION' | translate}}" placeholder="{{'TYPE_HERE' | translate}}"
        [(input)]="taxRateDto.description"></app-soc-text-field>
           
        <hr class="soc-panel-line">
        <div class="soc-wrapper-gap-12 d-flex justify-content-end">
            <button class="soc-secondary-grey-btn" type="button" (click)="close()">{{'CANCEL'| translate}}</button>
            <button class="soc-basic-cyan-btn" type="submit"
                (click)="editFlag? editTaxRate(f) : addTaxRate(f) ">{{(editFlag ?
                'SAVE_CHANGES' : 'CREATE')| translate}}</button>
        </div>
    </form>
</div>